import dayjs, { Dayjs } from 'dayjs';

// The bulk settlement endpoint rejects a range longer than this many days
const BULK_SETTLEMENT_MAX_DAYS = 60;
const BULK_SETTLEMENT_MAX_DAYS_BEFORE_TODAY = BULK_SETTLEMENT_MAX_DAYS - 1;

export function getEarliestBulkSettlementDate() {
  return dayjs.tz().subtract(BULK_SETTLEMENT_MAX_DAYS_BEFORE_TODAY, 'day');
}

export function getLatestBulkSettlementDate() {
  return dayjs.tz();
}

export function getBulkSettlementDateRange(
  startDate: Dayjs,
  endDate: Dayjs,
): [Dayjs, Dayjs] | undefined {
  const today = getLatestBulkSettlementDate();
  const earliestDate = getEarliestBulkSettlementDate();
  const clampedStartDate = startDate.isBefore(earliestDate) ? earliestDate : startDate;
  const clampedEndDate = endDate.isAfter(today) ? today : endDate;

  if (clampedStartDate.isAfter(clampedEndDate, 'day')) {
    return undefined;
  }

  return [clampedStartDate, clampedEndDate];
}
